import { getApiUrl } from './apiConfig';

export const ADOPTION_WIDGETS = [
  {
    key: 'newly_created_exercises',
    title: 'Newly Created Exercises',
    subtitle: 'Last 10 exercises added (newest first)',
    valueType: 'names',
    linkTarget: 'exercise',
  },
  {
    key: 'exercises_no_media',
    title: 'Exercises with no images or videos',
    subtitle: 'Missing display_url and display_images',
    valueType: 'count',
    linkTarget: 'exercise',
  },
  {
    key: 'exercise_types_no_exercises',
    title: 'Exercise types with no exercises',
    subtitle: 'Types with zero linked exercises',
    valueType: 'count',
    linkTarget: 'exerciseType',
  },
  {
    key: 'courses_no_exercise_types',
    title: 'Courses with no exercise types',
    subtitle: 'No types linked via exercise_type_course',
    valueType: 'names',
    linkTarget: 'course',
  },
  {
    key: 'courses_no_exercises',
    title: 'Courses with no exercises',
    subtitle: 'No exercises under any course type',
    valueType: 'names',
    linkTarget: 'course',
  },
  {
    key: 'grades_no_exercise_types',
    title: 'Grades with no exercise types',
    subtitle: 'No types linked via exercise_type_grade',
    valueType: 'count',
    linkTarget: null,
  },
  {
    key: 'grades_no_exercises',
    title: 'Grades with no exercises',
    subtitle: 'No exercises under any grade type',
    valueType: 'count',
    linkTarget: null,
  },
  {
    key: 'courses_incomplete_content',
    title: 'Courses missing summary, images, or video',
    subtitle: 'Empty summary, media, and external break links',
    valueType: 'count',
    linkTarget: 'course',
  },
  {
    key: 'courses_no_stories',
    title: 'Courses with no stories',
    subtitle: 'No story linked for this course name',
    valueType: 'count',
    linkTarget: 'story',
  },
];

export function adoptionDashboardUrl(requesterId) {
  return `${getApiUrl()}/api/adoption/dashboard?requester_id=${encodeURIComponent(String(requesterId))}`;
}

export function adoptionReportUrl(reportKey, requesterId, page = 1, limit = 50) {
  const qs = new URLSearchParams({
    requester_id: String(requesterId),
    page: String(page),
    limit: String(limit),
  });
  return `${getApiUrl()}/api/adoption/reports/${encodeURIComponent(reportKey)}?${qs.toString()}`;
}

export function widgetDisplayValue(widgetKey, dashboardData) {
  const block = dashboardData?.[widgetKey];
  if (!block) return '—';
  const widget = ADOPTION_WIDGETS.find((w) => w.key === widgetKey);
  if (widget?.valueType === 'names') {
    const names = block.names || [];
    if (names.length === 0) return '0';
    if (names.length <= 3) return names.join(', ');
    return `${names.slice(0, 3).join(', ')} +${names.length - 3} more`;
  }
  return String(block.count ?? 0);
}

export function widgetNumericValue(widgetKey, dashboardData) {
  const block = dashboardData?.[widgetKey];
  if (!block) return 0;
  return block.count ?? 0;
}
